import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Mail} from "../../../../classes/mail";

@Component({
    selector: 'kan-mail-list',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanMailList {
    @Input() public mails: Mail[];
    @Output() refresh: EventEmitter<any> = new EventEmitter();

    constructor() {

    }

    ngOnInit(): void {
    }

    public emitRefresh(): void {
        this.refresh.emit();
    }
}



// WEBPACK FOOTER //
// ./src/modules/mails/components/list/component.ts